import React from 'react';
import { GalleryEvent } from '../../types/Gallery';
import { TableColumn } from '../../utils/tableUtils';

// Define gallery event table columns
export const galleryEventColumns: TableColumn<GalleryEvent>[] = [
  {
    id: 'title',
    label: 'Title',
    sortable: true,
    accessor: (item: GalleryEvent) => (
      <div>
        <div className="font-medium text-gray-900">{item.title}</div>
        {item.description && (
          <div className="text-sm text-gray-500 truncate max-w-xs">
            {item.description}
          </div>
        )}
      </div>
    )
  },
  {
    id: 'date',
    label: 'Date',
    sortable: true,
    accessor: (item: GalleryEvent) => (
      <div className="text-sm text-gray-900">
        {new Date(item.date).toLocaleDateString()}
      </div>
    )
  },
  {
    id: 'eventType',
    label: 'Type',
    sortable: true,
    accessor: (item: GalleryEvent) => (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getEventTypeBadgeClass(item.eventType)}`}>
        {item.eventType}
      </span>
    )
  },
  {
    id: 'location',
    label: 'Location',
    sortable: false,
    accessor: (item: GalleryEvent) => (
      <div className="text-sm text-gray-900">
        {item.location || 'N/A'}
      </div>
    )
  },
  {
    id: 'images',
    label: 'Images',
    sortable: true,
    accessor: (item: GalleryEvent) => (
      <div className="text-sm text-gray-900">
        {item.images?.length || 0} images
      </div>
    )
  },
  {
    id: 'publicGallery',
    label: 'Visibility',
    sortable: true,
    accessor: (item: GalleryEvent) => {
      // Now using the correct field name from backend
      console.log('Backend publicGallery field:', item.publicGallery, 'type:', typeof item.publicGallery);

      // Simple boolean conversion since we now have the correct field
      const isPublic = Boolean(item.publicGallery);

      console.log('Computed isPublic:', isPublic);

      return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
          isPublic
            ? 'bg-green-100 text-green-800'
            : 'bg-red-100 text-red-800'
        }`}>
          {isPublic ? 'Public' : 'Private'}
        </span>
      );
    }
  },
  {
    id: 'actions',
    label: 'Actions',
    sortable: false,
    accessor: () => null // This will be handled by AdminTable automatically
  }
];

// Gallery event table configuration
export const galleryEventTableConfig = {
  entityName: 'Gallery Event',
  apiEndpoint: '/api/admin/gallery/events',
  columns: galleryEventColumns,
  searchFields: ['title', 'description', 'location'] as (keyof GalleryEvent)[],
  filterOptions: {
    eventType: [
      { value: 'Concert', label: 'Concert' },
      { value: 'Competition', label: 'Competition' },
      { value: 'Fundraiser', label: 'Fundraiser' },
      { value: 'Community Event', label: 'Community Event' },
      { value: 'Rehearsal', label: 'Rehearsal' },
      { value: 'Other', label: 'Other' }
    ],
    publicGallery: [
      { value: 'true', label: 'Public' },
      { value: 'false', label: 'Private' }
    ],
    location: [] as { value: string; label: string }[]
  },
  exportFileName: 'gallery-events',
  defaultVisibleColumns: {
    title: true,
    date: true,
    eventType: true,
    location: true,
    images: true,
    publicGallery: true,
    actions: true
  }
};

function getEventTypeBadgeClass(eventType: string): string {
  switch (eventType) {
    case 'Concert':
      return 'bg-blue-100 text-blue-800';
    case 'Competition':
      return 'bg-purple-100 text-purple-800';
    case 'Fundraiser':
      return 'bg-green-100 text-green-800';
    case 'Community Event':
      return 'bg-yellow-100 text-yellow-800';
    case 'Rehearsal':
      return 'bg-gray-100 text-gray-800';
    case 'Other':
      return 'bg-orange-100 text-orange-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}
